import React, { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Lock, Loader2, Mail } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import KazemLogo from "@/components/KazemLogo";
import { toast } from "sonner";
import { formatErr } from "@/lib/api";

export default function TmsLoginPage() {
    const { user, login } = useAuth();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    if (user && user.email) return <Navigate to="/tms" replace />;

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await login(email.trim().toLowerCase(), password);
            toast.success("Connexion établie");
            navigate("/tms");
        } catch (err) {
            toast.error(formatErr(err.response?.data?.detail) || "Identifiants invalides");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-[#0b2545] flex items-center justify-center px-5 py-12 relative overflow-hidden">
            <img src="/img/port.jpg" alt="" className="absolute inset-0 w-full h-full object-cover opacity-25" />
            <div className="relative w-full max-w-md">
                <div className="flex justify-center mb-10">
                    <KazemLogo light size="lg" />
                </div>
                <div className="rounded-2xl border border-white/10 bg-[#111c38] p-8 shadow-2xl">
                    <div className="text-xs uppercase tracking-[0.3em] text-orange-400 font-semibold">
                        Accès TMS interne
                    </div>
                    <h1 className="font-display text-2xl font-bold text-white mt-2">Connexion</h1>
                    <p className="text-sm text-slate-400 mt-1">
                        Réservé aux équipes Kazem Logistics.
                    </p>

                    <form onSubmit={submit} className="mt-8 space-y-4">
                        <div>
                            <label className="text-sm text-slate-300 mb-2 block">Email</label>
                            <div className="relative">
                                <Mail className="absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-500" size={16} />
                                <input
                                    data-testid="tms-login-email-input"
                                    type="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                    className="w-full pl-10 pr-4 py-3 rounded-xl bg-[#0b1329] border border-white/15 text-white focus:outline-none focus:border-orange-400"
                                    placeholder="vous@kazemlogistics.com"
                                    autoComplete="email"
                                />
                            </div>
                        </div>
                        <div>
                            <label className="text-sm text-slate-300 mb-2 block">Mot de passe</label>
                            <div className="relative">
                                <Lock className="absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-500" size={16} />
                                <input
                                    data-testid="tms-login-password-input"
                                    type="password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                    className="w-full pl-10 pr-4 py-3 rounded-xl bg-[#0b1329] border border-white/15 text-white focus:outline-none focus:border-orange-400"
                                    placeholder="••••••••"
                                    autoComplete="current-password"
                                />
                            </div>
                        </div>

                        <button
                            type="submit"
                            data-testid="tms-login-submit-button"
                            disabled={loading}
                            className="kz-btn-primary w-full justify-center mt-2"
                        >
                            {loading ? <Loader2 className="animate-spin" size={16} /> : <Lock size={16} />}
                            Se connecter
                        </button>
                    </form>

                    <p className="text-xs text-slate-500 mt-6 text-center">
                        Mot de passe oublié ? Contactez l'administrateur.
                    </p>
                </div>
            </div>
        </div>
    );
}
